"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizableError = exports.LocalizedError = void 0;
var errors_1 = require("./errors");
Object.defineProperty(exports, "LocalizedError", { enumerable: true, get: function () { return errors_1.LocalizedError; } });
Object.defineProperty(exports, "LocalizableError", { enumerable: true, get: function () { return errors_1.LocalizableError; } });
